import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { useDashboard } from './useDashboard';
import { fetchJSON, AuthError } from '@/api/client';

export interface ServiceInfo { name: string; status: string; latencyMs?: number; }
export interface OrgOverview { id: string; name: string; organStatus: string; bridgeStatus: string; peerStatus: string; services: ServiceInfo[]; }
export interface OverviewData { health: { status: string; orgs?: OrgOverview[] } | null; error: string | null; timestamp: string; }

export function useOverview() {
  const { token, logout } = useAuth();
  const { refreshKey } = useDashboard();
  const [data, setData] = useState<OverviewData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    fetchJSON<OverviewData>('/api/dashboard/overview', token)
      .then((d) => { if (!cancelled) { setData(d); setLoading(false); } })
      .catch((e) => {
        if (e instanceof AuthError) { logout(); return; }
        if (!cancelled) {
          setData({ health: null, error: e instanceof Error ? e.message : 'Failed', timestamp: new Date().toISOString() });
          setLoading(false);
        }
      });
    return () => { cancelled = true; };
  }, [token, refreshKey, logout]);

  return { data, loading };
}
